import type { UserDetailsResponse } from '~/services/modules/users/types';

/** DDDs em uso no Brasil (Anatel). */
const VALID_DDDS = new Set([
  11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48,
  49, 51, 53, 54, 55, 61, 62, 63, 64, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88, 89,
  91, 92, 93, 94, 95, 96, 97, 98, 99
]);

/** Telefone nulo, indefinido, "" ou só espaços conta como ausente. */
export const isBlankPhone = (phone?: string | null): boolean => !phone || phone.trim() === '';

export const onlyPhoneDigits = (phone: string): string => phone.replace(/\D/g, '');

/** Celular BR: DDD válido + 9 dígitos começando com 9 (11 dígitos no total, com ou sem máscara). */
export const isValidBrazilianMobile = (phone: string): boolean => {
  const digits = onlyPhoneDigits(phone ?? '');
  if (!/^\d{11}$/.test(digits)) return false;

  return VALID_DDDS.has(Number(digits.slice(0, 2))) && digits[2] === '9';
};

/**
 * Cadastro encontrado sem telefone (CORE-1025): o SMS não pode ser usado e o telefone é pedido após o código.
 * `has_phone` é a fonte da verdade; sem ele, cai para `masked_phone` nulo/vazio/espaços — mas só quando o campo
 * veio na resposta, para um shape antigo (sem os dois campos) manter o fluxo de hoje.
 */
export const userHasNoPhone = (userData?: Partial<UserDetailsResponse> | null): boolean => {
  if (!userData) return false;
  if (typeof userData.has_phone === 'boolean') return !userData.has_phone;
  return 'masked_phone' in userData && isBlankPhone(userData.masked_phone);
};
